import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-performance",
  templateUrl: "./med-icon-performance.component.html",
})
export class MedIconPerformanceComponent extends SvgMixinComponent {}
